export const exchangeToRegion = {
    // UK & Ireland
    'L': 'GB', 'LSE': 'GB',
    'IE': 'IE',
    
    // Europe - Germany & Central
    'DE': 'DE', 'F': 'DE', 'D': 'DE', 'EX': 'DE',
    'AS': 'NL', // Amsterdam
    'PA': 'FR', 'EP': 'FR', // Paris
    'VI': 'AT', // Vienna
    'SW': 'CH', // Swiss
    'BR': 'BE', // Brussels
    'MA': 'ES', // Madrid
    'MC': 'ES', // Barcelona
    'LI': 'PT', // Lisbon
    'AT': 'GR', // Athens
    
    // Scandinavia
    'ST': 'SE', // Stockholm
    'OL': 'NO', // Oslo
    'CO': 'DK', // Copenhagen
    'HE': 'FI', // Helsinki
    
    // Eastern Europe
    'WA': 'PL', // Warsaw
    'PR': 'CZ', // Prague
    'BU': 'HU', // Budapest
    
    // North America
    'TO': 'CA', // Toronto
    'V': 'CA',  // TSX Venture
    'MX': 'MX', // Mexico
    
    // South America
    'SA': 'BR', // São Paulo
    'AR': 'AR', // Buenos Aires
    'SN': 'CL', // Santiago
    
    // Asia Pacific
    'HK': 'HK', // Hong Kong
    'T': 'JP',  // Tokyo
    'SS': 'CN', // Shanghai
    'SZ': 'CN', // Shenzhen
    'KS': 'KR', // Korea (Seoul)
    'KQ': 'KR', // Korea (KOSDAQ)
    'SI': 'SG', // Singapore
    'BK': 'TH', // Bangkok
    'KL': 'MY', // Kuala Lumpur
    'JK': 'ID', // Jakarta
    'PS': 'PH', // Philippines
    'HS': 'VN', // Ho Chi Minh (Vietnam)
    'NZ': 'NZ', // New Zealand
    'AX': 'AU', // Australia
    
    // India
    'BO': 'IN', // Bombay
    'NS': 'IN', // NSE India
    'CS': 'IN', // CSE India
    
    // Middle East
    'DU': 'AE', // Dubai
    'AB': 'SA', // Saudi Arabia
    'TA': 'IL', // Tel Aviv
    
    // Africa
    'JO': 'ZA', // Johannesburg
    'CA': 'EG', // Cairo
    
    // Other
    'RX': 'RU', // Moscow (Russia)
    'TI': 'TR', // Istanbul (Turkey)
  };